import React, { useEffect, useState } from "react";
import "./Report.scss";
import PrintDocumentTemplate from "../../../../Components/PrintDocumentTemplate/PrintDocumentTemplate";
import moment from "moment";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { get } from "lodash";
import slownie from "liczby-slownie";
import { currencyFormat } from "../../../../Utils/Currency/currency";
import { chunkedArray } from "../../../../Utils/Arrays/arrays";

const ReportComponent = () => {
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const resLogo = await GlobalAuthFetch({ path: "/settings/LOGO" });

      setLogo(resLogo?.payload?.data?.value);
    };
    loadData();
  }, []);

  return (
    <div className="LogoArea">
      {Boolean(logo) ? <img className="Logo" alt="Logo" src={logo} /> : null}
    </div>
  );
};

export const Report = () => {
  // const [users, setUsers] = useState([]);

  let LP = 0;
  const headersFlex = [
    { key: "lp", name: "Lp." },
    {
      key: "modelAndSN",
      name: (
        <div className="d-flex flex-column">
          <span>Model urządzenia</span>
          <span>Numer seryjny</span>
        </div>
      ),
    },
    {
      key: "rentAndMonitoring",
      name: (
        <div className="d-flex flex-column">
          <span>Najem</span>
          <span>Monitoring</span>
        </div>
      ),
    },
    {
      key: "countersMono",
      name: (
        <div className="d-flex flex-column">
          <span>Koszty wydruku mono</span>
          <span>Liczniki mono</span>
          <span>Nakład mono</span>
          <span>Koszt nakładu mono</span>
        </div>
      ),
    },
    {
      key: "countersColor",
      name: (
        <div className="d-flex flex-column">
          <span>Koszty wydruku kolor</span>
          <span>Liczniki kolor</span>
          <span>Nakład kolor</span>
          <span>Koszt nakładu kolor</span>
        </div>
      ),
    },
    {
      key: "countersScan",
      name: (
        <div className="d-flex flex-column">
          <span>Koszt skanów</span>
          <span>Liczniki skanów</span>
          <span>Liczba skanów</span>
          <span>Koszt nakładu skanów</span>
        </div>
      ),
    },
    {
      key: "monthCost",
      name: (
        <div className="d-flex flex-column">
          <span>Koszt miesięczny</span>
        </div>
      ),
    },
  ];

  const headersSub = [
    { key: "lp", name: "Lp." },
    {
      key: "modelAndSN",
      name: (
        <div className="d-flex flex-column">
          <span>Model urządzenia</span>
          <span>Numer seryjny</span>
        </div>
      ),
    },
    {
      key: "rentSubscription",
      name: (
        <div className="d-flex flex-column">
          <span>
            <b>Abonament:</b>
          </span>
          <span>Cena</span>
          <span>Pakiet wydruków mono</span>
          <span>Pakiet wydruków kolor</span>
          <span>Pakiet skanów</span>
        </div>
      ),
    },
    {
      key: "monoOverSubscription",
      name: (
        <div className="d-flex flex-column">
          <span>
            <b>Mono ponad abonament:</b>
          </span>
          <span>Koszt 1 wydruku</span>
          <span>Nakład płatny</span>
          <span>Koszt nakładu</span>
        </div>
      ),
    },
    {
      key: "colorOverSubscription",
      name: (
        <div className="d-flex flex-column">
          <span>
            <b>Kolor ponad abonament:</b>
          </span>
          <span>Koszt 1 wydruku</span>
          <span>Nakład płatny</span>
          <span>Koszt nakładu</span>
        </div>
      ),
    },
    {
      key: "scanOverSubscription",
      name: (
        <div className="d-flex flex-column">
          <span>
            <b>Skany:</b>
          </span>
          <span>Koszt 1 skanu</span>
          <span>Ilość</span>
        </div>
      ),
    },
    {
      key: "monthCost",
      name: (
        <div className="d-flex flex-column">
          <span>Koszt miesięczny</span>
        </div>
      ),
    },
  ];

  // const loadData = async () => {
  //   const res = await GlobalAuthFetch({ path: "/representative/all" });
  //   if (!res.payload) {
  //     return;
  //   }
  //   setUsers(
  //     res?.payload?.data?.map((user) => ({
  //       label: `${user?.name || ""} ${user?.lastname} ${user?.email}`,
  //       uuid: user?.email,
  //     }))
  //   );
  // };

  // useEffect(() => {
  //   loadData();
  //   // eslint-disable-next-line
  // }, []);

  const printData = JSON.parse(sessionStorage.getItem("printData"));

  const dataArraySub = chunkedArray(
    printData?.listDevicesOnReckoning.filter(
      (el) => el.contractType === "SUBSCRIPTION"
    ),
    {
      chunkSize: 6,
    }
  );

  const dataArrayFlex = chunkedArray(
    printData?.listDevicesOnReckoning.filter(
      (el) => el.contractType === "FLEXIBLE"
    ),
    {
      chunkSize: 6,
    }
  );
  const DEFAULT = Number(0);
  const dataToXls = printData?.listDevicesOnReckoning?.map((el, idx) => ({
    "Lp.": idx + 1,
    "Model urządzenia": `${el?.device?.printerModel?.manufacturer?.entryName} ${el?.device?.printerModel?.modelName}`,
    "Oddział": el?.device?.branch?.name,
    "Lokalizacja urządzenia": el?.device?.addressFloor,
    "S/N": el?.device?.serialNumber,
    "Koszt miesięczny": el?.fullCosts?.toFixed(2),
    "\n": " ",
    "Abonament": el?.contractType === "SUBSCRIPTION" ? el?.subscription?.toFixed(2) : DEFAULT?.toFixed(2),
    "Koszt wydruków mono \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyMonoAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
    "Liczba wydruków mono \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyMonoAbove : DEFAULT,
    "Koszt wydruków kolor \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyColorAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
    "Liczba wydruków kolor \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyColorAbove : DEFAULT,
    " \n ": " ",
    "Najem": el?.contractType === "FLEXIBLE" ? el?.subscription?.toFixed(2) : DEFAULT?.toFixed(2),
    // "Monitoring": el?.monitoringCost,
    // "Koszt wydruku mono": el?.monoSingleCost,
    "Koszt wydruków mono": el?.contractType === "FLEXIBLE" ? el?.monthlyMonoAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
    "Liczba wydruków mono": el?.contractType === "FLEXIBLE" ? el?.monthlyMonoAbove : DEFAULT,
    // "Koszt wydruku kolor": el?.colorSingleCost,    
    "Koszt wydruków kolor": el?.contractType === "FLEXIBLE" ? el?.monthlyColorAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
    "Liczba wydruków kolor": el?.contractType === "FLEXIBLE" ? el?.monthlyColorAbove : DEFAULT,
    // "Koszt wydruku skan": el?.monthlyScanCost,
    // "Nakład skan": el?.monthlyScanAbove,
    // "Koszt nakładu skan": el?.monthlyScanAboveCost,
  }))

  const headerColors = [
    "FFF5CBA7",
    "FF9BBB59",
    "FF8064A2",
    "f5b227",
    "FF4F81BD",
    "FF9BC2E6",
    "BAF1BF",
  ];

  const dataColors = [
    "FFFBE9DC",
    "FFD9EAD3",
    "FFEADCF0",
    "FFE89C",
    "FFDCE6F1",
    "FFE9F2FB",
    "E6EBD7",
  ];

  const colorRanges = [
    { range: [1, 5], header: headerColors[0], data: dataColors[0] },
    { range: [6, 6], header: headerColors[1], data: dataColors[1] },

    { range: [8, 8], header: headerColors[2], data: dataColors[2] },
    { range: [9, 10], header: headerColors[6], data: dataColors[6] },
    { range: [11, 12], header: headerColors[5], data: dataColors[5] },

    { range: [14, 14], header: headerColors[0], data: dataColors[0] },
    { range: [15, 16], header: headerColors[4], data: dataColors[4] },
    { range: [17, 18], header: headerColors[5], data: dataColors[5] },
  ];

  const calcBrutto = printData.monthCost * 1.23;

  return (
    <PrintDocumentTemplate
      fileName={`Rozliczenie umowy: ${printData?.index || "-"}`}
      usersToSendEmail={[
        ...(printData?.generateFromRentContract?.accountReceiverEmail
          ?.split(",")
          .map((el) => el.trim()) ?? []),
      ]}
      optimaCheckBox={true}
      printDataOptimaId={printData?.optimaDocumentId}
      printData={printData}
      dataToXls={dataToXls}
      colorRanges={colorRanges}
      documentType="FaVatAndReport"
    >
      {[
        ...dataArrayFlex.map((table, mainIndex) => (
          <div className="TargetPrintRaportAreaFrom">
            <div className="HeaderArea">
              <ReportComponent />
              <span className="DateArea">
                <span>
                  Data wystawienia:{" "}
                  {moment(printData?.createdAt).format("DD-MM-YYYYr")}
                </span>
              </span>
            </div>
            <div className="HeaderEnd">
              {" "}
              <span className="InnerText">RAPORT</span>
            </div>
            <div className="InfoArea">
              <div>
                <span className="Client">Klient:</span>
                <span>
                  {printData?.generateFromRentContract?.contact?.name || " "}
                </span>
                <span>
                  ul.
                  {printData?.generateFromRentContract?.contact?.street ||
                    " "},{" "}
                  {printData?.generateFromRentContract?.contact?.postCode ||
                    " "}{" "}
                  {printData?.generateFromRentContract?.contact?.city || " "}
                </span>
                <span>
                  NIP:{" "}
                  {printData?.generateFromRentContract?.contact?.nip || " "}
                </span>
              </div>
              <div>
                <div>
                  <span className="d-flex justify-content-between">
                    Raport do faktury:
                    <span>{printData?.invoiceNumber}</span>
                  </span>
                  <span className="d-flex justify-content-between">
                    <span>Numer umowy</span>
                    <span>
                      {printData?.generateFromRentContract?.contractNo || " "}
                    </span>
                  </span>
                  <span className="d-flex justify-content-between">
                    <span>ID rozliczenia</span>
                    <span>{printData?.index || " "}</span>
                  </span>
                  <span className="d-flex justify-content-between">
                    <span>Data rozliczenia</span>
                    <span>
                      {moment(printData?.createdAt).format("DD-MM-YYYYr")}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            {mainIndex === dataArrayFlex.length - 1 &&
              dataArraySub.length <= 0 ? (
              <div
                className="SummaryArea"
                word-summary={`${slownie(
                  calcBrutto.toFixed(2).split(".")[0]
                )} złotych i ${slownie(
                  calcBrutto.toFixed(2).split(".")[1] === "00" ||
                    !calcBrutto.toFixed(2).split(".")[1]
                    ? 0
                    : calcBrutto.toFixed(2).split(".")[1]
                )} groszy`}
              >
                <span>Razem brutto do zapłaty:</span>
                <span>{currencyFormat(calcBrutto)}</span>
              </div>
            ) : null}
            <div className="TablePrintArea">
              <table>
                <thead>
                  <tr>
                    {headersFlex.map((header, index) => (
                      <th key={`Header-${index}`}>{header.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ...table.map((el) => ({
                      modelAndSN: (
                        <div className="d-flex flex-column">
                          <span>
                            {el?.device?.printerModel?.manufacturer
                              ?.entryName || ""}{" "}
                            {el?.device?.printerModel?.modelName || ""}
                          </span>
                          <span>{el?.device?.serialNumber || ""}</span>
                        </div>
                      ),
                      rentAndMonitoring: (
                        <div className="d-flex flex-column">
                          <span>{currencyFormat(el?.rentalCost)}</span>
                          <span>{currencyFormat(el?.monitoringCost)}</span>
                        </div>
                      ),
                      countersMono: (
                        <div className="d-flex flex-column">
                          <span>
                            {currencyFormat(el?.monoSingleCost, { fixed: 3 })}
                          </span>
                          <span>
                            {el?.beforeCounterMono?.toFixed(0) || "0"} -{" "}
                            {el?.currentCounterMono?.toFixed(0) || "0"}
                          </span>
                          <span>{el?.monthlyMono?.toFixed(0) || "0"}</span>
                          <span>{currencyFormat(el?.monthlyMonoCost)}</span>
                        </div>
                      ),
                      countersColor: (
                        <div className="d-flex flex-column">
                          <span>
                            {currencyFormat(el?.colorSingleCost, { fixed: 3 })}
                          </span>
                          <span>
                            {el?.beforeCounterColor?.toFixed(0) || "0"} -{" "}
                            {el?.currentCounterColor?.toFixed(0) || "0"}
                          </span>
                          <span>{el?.monthlyColor?.toFixed(0) || "0"}</span>
                          <span>{currencyFormat(el?.monthlyColorCost)}</span>
                        </div>
                      ),
                      countersScan: (
                        <div className="d-flex flex-column">
                          <span>
                            {currencyFormat(el?.scanSingleCost, { fixed: 3 })}
                          </span>
                          <span>
                            {el?.beforeCounterScan?.toFixed(0) || "0"} -{" "}
                            {el?.currentCounterScan?.toFixed(0) || "0"}
                          </span>
                          <span>{el?.monthlyScan?.toFixed(0) || "0"}</span>
                          <span>{currencyFormat(el?.monthlyScanCost)}</span>
                        </div>
                      ),
                      monthCost: (
                        <div className="d-flex flex-column">
                          <span>{currencyFormat(el?.fullCosts)}</span>
                        </div>
                      ),
                      ...el,
                    })),
                  ]?.map((data) => {
                    LP += 1;
                    return (
                      <tr key={`dataHeader-${LP}`}>
                        {headersFlex.map((header, idx) => (
                          <td key={`data-${idx}`}>
                            {header.key === "lp"
                              ? LP
                              : get(data, header.key, "-")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {mainIndex === dataArrayFlex.length - 1 &&
                dataArraySub.length <= 0 ? (
                <div className="TableFooter">
                  <span>Dziękujemy za korzystanie z naszych usług.</span>
                  <b>
                    Razem netto:{" "}
                    <b className="ms-4">
                      {currencyFormat(printData?.monthCost)}
                    </b>
                  </b>
                </div>
              ) : null}
            </div>
            <div className="Footer">www.biuromax-balcer.pl</div>
          </div>
        )),
        ...dataArraySub.map((table, mainIndex) => (
          <div className="TargetPrintRaportAreaFrom">
            <div className="HeaderArea">
              <ReportComponent />
              <span className="DateArea">
                <span>
                  Data wystawienia:{" "}
                  {moment(printData?.createdAt).format("DD-MM-YYYYr")}
                </span>
              </span>
            </div>
            <div className="HeaderEnd">
              {" "}
              <span className="InnerText">RAPORT</span>
            </div>
            <div className="InfoArea">
              <div>
                <span className="Client">Klient:</span>
                <span>
                  {printData?.generateFromRentContract?.contact?.name || " "}
                </span>
                <span>
                  ul.
                  {printData?.generateFromRentContract?.contact?.street ||
                    " "},{" "}
                  {printData?.generateFromRentContract?.contact?.postCode ||
                    " "}{" "}
                  {printData?.generateFromRentContract?.contact?.city || " "}
                </span>
                <span>
                  NIP:{" "}
                  {printData?.generateFromRentContract?.contact?.nip || " "}
                </span>
              </div>
              <div>
                <div>
                  <span className="d-flex justify-content-between">
                    Raport do faktury:
                    <span>{printData?.invoiceNumber}</span>
                  </span>
                  <span className="d-flex justify-content-between">
                    <span>Numer umowy</span>
                    <span>
                      {printData?.generateFromRentContract?.contractNo || " "}
                    </span>
                  </span>
                  <span className="d-flex justify-content-between">
                    <span>ID rozliczenia</span>
                    <span>{printData?.index || " "}</span>
                  </span>
                  <span className="d-flex justify-content-between">
                    <span>Data rozliczenia</span>
                    <span>
                      {moment(printData?.createdAt).format("DD-MM-YYYYr")}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            {mainIndex === dataArraySub.length - 1 ? (
              <div
                className="SummaryArea"
                word-summary={`${slownie(
                  calcBrutto.toFixed(2).split(".")[0]
                )} złotych i ${slownie(
                  calcBrutto.toFixed(2).split(".")[1] === "00" ||
                    !calcBrutto.toFixed(2).split(".")[1]
                    ? 0
                    : calcBrutto.toFixed(2).split(".")[1]
                )} groszy`}
              >
                <span>Razem brutto do zapłaty:</span>
                <span>{currencyFormat(calcBrutto)}</span>
              </div>
            ) : null}
            <div className="TablePrintArea">
              <table>
                <thead>
                  <tr>
                    {headersSub.map((header, index) => (
                      <th key={`Header-${index}`}>{header.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ...table.map((el) => ({
                      modelAndSN: (
                        <div className="d-flex flex-column">
                          <span>
                            {el?.device?.printerModel?.manufacturer
                              ?.entryName || ""}{" "}
                            {el?.device?.printerModel?.modelName || ""}
                          </span>
                          <span>{el?.device?.serialNumber || ""}</span>
                        </div>
                      ),
                      rentSubscription: (
                        <div className="d-flex flex-column">
                          <span>{currencyFormat(el?.subscription)}</span>
                          <span>{el?.monoPackageSize || "0"}</span>
                          <span>{el?.colorPackageSize || "0"}</span>
                          <span>{"Nieograniczony"}</span>
                        </div>
                      ),
                      monoOverSubscription: (
                        <div className="d-flex flex-column">
                          <span>
                            {currencyFormat(el?.monoSingleCost, { fixed: 3 })}
                          </span>
                          <span>
                            {el?.monthlyMonoAbove > 0
                              ? el?.monthlyMonoAbove
                              : "0"}
                          </span>
                          <span>
                            {currencyFormat(el?.monthlyMonoAboveCost)}
                          </span>
                        </div>
                      ),
                      colorOverSubscription: (
                        <div className="d-flex flex-column">
                          <span>
                            {currencyFormat(el?.colorSingleCost, { fixed: 3 })}
                          </span>
                          <span>
                            {el?.monthlyColorAbove > 0
                              ? el?.monthlyColorAbove
                              : "0"}
                          </span>
                          <span>
                            {currencyFormat(el?.monthlyColorAboveCost)}
                          </span>
                        </div>
                      ),
                      scanOverSubscription: (
                        <div className="d-flex flex-column">
                          <span>
                            {currencyFormat(el?.scanSingleCost, { fixed: 3 })}
                          </span>
                          <span>
                            {el?.monthlyScanAbove > 0
                              ? el?.monthlyScanAbove
                              : "0"}
                          </span>
                        </div>
                      ),
                      monthCost: (
                        <div className="d-flex flex-column">
                          <span>{currencyFormat(el?.fullCosts)}</span>
                        </div>
                      ),
                      ...el,
                    })),
                  ]?.map((data) => {
                    LP += 1;
                    return (
                      <tr key={`dataHeader-${LP}`}>
                        {headersSub.map((header, idx) => (
                          <td key={`data-${idx}`}>
                            {header.key === "lp"
                              ? LP
                              : get(data, header.key, "-")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {mainIndex === dataArraySub.length - 1 ? (
                <div className="TableFooter">
                  <span>Dziękujemy za korzystanie z naszych usług.</span>
                  <b>
                    Razem netto:{" "}
                    <b className="ms-4">
                      {currencyFormat(printData?.monthCost)}
                    </b>
                  </b>
                </div>
              ) : null}
            </div>

            <div className="Footer">www.biuromax-balcer.pl</div>
          </div>
        )),
      ]}
    </PrintDocumentTemplate>
  );
};
